






















































import Vue from 'vue';
import moment from 'moment';
import { mapActions } from 'vuex';
import { Component } from 'vue-property-decorator';
import UpdateEmailTemplateModal from './components/UpdateEmailTemplateModal.vue';

@Component({
    filters: {
        dateFormat(value: string) {
            return moment(value).format('lll');
        }
    },
    methods: {
        ...mapActions('bh-email-template', { createNewEmailTemplate: 'create' })
    },
    components: {
        UpdateEmailTemplateModal
    }
})
export default class EmailTemplateManager extends Vue {

    dialogAddTemplate = false;
    dialogAddTemplateLoading = false;

    query = {};
    pagination = {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: []
    };

    headers = [
        {
            text: 'ID',
            align: 'start',
            sortable: true,
            value: 'id',
        },
        {
            text: 'Name/Description',
            align: 'start',
            sortable: false,
            value: 'name'
        },
        {
            text: 'Create Date',
            align: 'end',
            softable: false,
            value: 'createdAt'
        },
        {
            text: '',
            align: 'end',
            softable: false,
            value: 'data-table-expand'
        }
    ];

    form = {
        alias: '',
        name: '',
        description: null,
        subject: null,
        template: null,
        data: null
    };

    successMessage = false;
    error = {
        show: false,
        message: ''
    };

    createNewEmailTemplate: any;

    public onFormError(err: any) {
        this.error.message = err.message;
        this.error.show = true;
    }
    
    public async addEmailTemplate() {
        this.form.alias = this.form.name.toLowerCase().replace(/\W/g, '-').replace(/-+?/g, '-');
        try {
            await this.createNewEmailTemplate(this.form);
            this.successMessage = true;
            this.dialogAddTemplate = false;
            this.form.alias = '';
            this.form.name = '';
            this.form.description = null;
            this.form.subject = null;
            this.form.template = null;
            this.form.data = null;
        } catch(err) {
            this.error.message = err.message;
            this.error.show = true;
        }
    }

    public get fetchQuery() {
        return Object.assign({}, {
            ...this.query,
            // ...this.extendedQuery,
            $populate: true
        }, {
            // ...this.searchQuery,
            $limit: this.pagination.itemsPerPage,
            $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
            ...this.sortingQuery
        });
    }

    public get dataQuery() {
        return {
            ...this.query,
            // ...this.extendedQuery,
            // ...this.searchDataQuery,
            $limit: this.pagination.itemsPerPage,
            $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
            ...this.sortingQuery
        };
    }

    public get sortingQuery() {
        if(this.pagination.sortBy.length !== 0) {
            const $sort: any = {};
            this.pagination.sortBy.map((item, index) => {
                switch(item) {
                    default:
                        $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                }
                
            });
            return { $sort };
        }
        return null;
    }

}
